module.exports = __webpack_public_path__ + "img/doctor-info.d58863bd.png";